export default function FileUploadIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M16.9298 9.21007C16.9365 9.21004 16.9432 9.21003 16.95 9.21003C19.1868 9.21003 21 10.9593 21 13.1172C21 15.1283 19.425 16.7845 17.4 17.0005M16.9298 9.21007C16.9432 9.06707 16.95 8.92225 16.95 8.7759C16.95 6.13851 14.7338 4.00049 12 4.00049C9.41092 4.00049 7.2861 5.91814 7.06838 8.36149M16.9298 9.21007C16.8378 10.1951 16.4357 11.0938 15.8185 11.8148M7.06838 8.36149C4.78558 8.57105 3 10.4259 3 12.683C3 14.7833 4.54598 16.5353 6.6 16.9375M7.06838 8.36149C7.21043 8.34844 7.35441 8.34177 7.5 8.34177C8.51324 8.34177 9.44827 8.66484 10.2004 9.21003"
        stroke="#455468"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 13.0005V20.0005M12 13.0005C11.4398 13.0005 10.3932 14.7455 10 15.188M12 13.0005C12.5602 13.0005 13.6068 14.7455 14 15.188"
        stroke="#455468"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
